
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.337 12.883c.353-.18.626-.363.838-.543l.403-.341-.362-.384a6.995 6.995 0 01-.778-.983l-.419.273.42-.273C.81 9.67.5 8.648.5 7.588.5 4.358 3.98.5 10.18.5c6.186 0 9.678 3.848 9.678 7.088 0 .87-.25 1.79-.734 2.656l.436.244-.436-.244c-.469.837-1.13 1.596-1.972 2.254h0a9.835 9.835 0 01-3.024 1.58h0c-1.212.395-2.54.597-3.948.597-1 0-1.976-.11-2.911-.326l-.183-.043-.166.089c-1.745.934-3.383 1.39-4.883 1.39-.71 0-1.327-.486-1.493-1.175h0a1.536 1.536 0 01.794-1.727zm0 0l-.228-.445.228.445s0 0 0 0zm22.544 4.46h0a1.536 1.536 0 01-1.488 1.157c-1.263 0-2.634-.391-4.088-1.198l-.168-.093-.186.043c-1.358.311-2.854.35-4.28.091a14.145 14.145 0 002.752-.9 9.146 9.146 0 001.866-.352c.95.59 2.486 1.373 4.104 1.373l.24-.939c-1.061-.578-1.485-1.24-1.646-1.838 1.043-.857 1.906-2.113 1.906-3.645 0-.465-.095-.941-.272-1.407a8.023 8.023 0 00.263-1.688c.687.98 1.044 2.061 1.044 3.095 0 1.304-.495 2.514-1.365 3.542l-.338.4.415.32c.136.103.297.208.488.312.616.336.926 1.047.753 1.728zM1.808 13.806l.228.945c1.93 0 3.773-.892 4.907-1.555 1.067.306 2.16.445 3.236.445 5.37 0 8.642-3.205 8.642-6.052 0-2.846-3.275-6.052-8.642-6.052-5.368 0-8.643 3.206-8.643 6.052 0 1.725 1.044 3.133 2.292 4.084-.19.69-.706 1.46-2.02 2.133z","stroke":"currentColor"}})])
          )
        }
      }
    